import { NavLink, useNavigate } from "react-router-dom";
import { Home, Map, Users, User, Plus } from "lucide-react";

const items = [
  { to: "/sales/home", icon: Home, label: "Home", testId: "nav-home" },
  { to: "/sales/tracking", icon: Map, label: "Tracking", testId: "nav-tracking" },
  { to: "/sales/prospek", icon: Users, label: "Prospek", testId: "nav-prospects" },
  { to: "/sales/profile", icon: User, label: "Profil", testId: "nav-profile" },
];

export const BottomNav = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-honda-border safe-area-bottom"
    >
      <div className="relative grid grid-cols-5 h-16">
        {/* Left two items */}
        {items.slice(0, 2).map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 transition-colors ${
                isActive ? "text-honda-red" : "text-honda-subtle hover:text-honda-ink"
              }`
            }
          >
            <Icon size={20} strokeWidth={2.2} />
            <span className="text-[10px] font-semibold tracking-wide">{label}</span>
          </NavLink>
        ))}

        {/* Center FAB placeholder */}
        <div className="flex items-center justify-center">
          <button
            data-testid="nav-fab-add"
            onClick={() => navigate("/sales/add")}
            className="w-14 h-14 -mt-7 rounded-full bg-honda-red text-white flex items-center justify-center shadow-lg shadow-honda-red/40 hover:bg-honda-red-hover transition-all active:scale-95 animate-pulse-red"
            aria-label="Tambah Prospek"
          >
            <Plus size={26} strokeWidth={2.5} />
          </button>
        </div>

        {/* Right two items */}
        {items.slice(2).map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 transition-colors ${
                isActive ? "text-honda-red" : "text-honda-subtle hover:text-honda-ink"
              }`
            }
          >
            <Icon size={20} strokeWidth={2.2} />
            <span className="text-[10px] font-semibold tracking-wide">{label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};
